function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// You can blame Sam Huckaby for this file © 2018
export var DynamicDestinations =
/*#__PURE__*/
function () {
  function DynamicDestinations($stateParams, $timeout, DestinationResourceFactory) {
    _classCallCheck(this, DynamicDestinations);

    /* BINDABLE : INJECTS */
    Object.assign(this, {
      $stateParams: $stateParams,
      $timeout: $timeout,
      DestinationResourceFactory: DestinationResourceFactory
    });
    /* BINDABLE : DATA */

    var scrubbedParams = angular.copy($stateParams);
    delete scrubbedParams.id;
    this.SearchParams = scrubbedParams;
    /* EVENTS */
    //Register any event listeners
    // Start things rolling

    this.reloadPages_();
  }
  /* IMPLEMENTATION : BINDABLE */


  _createClass(DynamicDestinations, [{
    key: "getItemAtIndex",
    value: function getItemAtIndex(index, lazy) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber];
      lazy = lazy === undefined ? false : lazy;

      if (page) {
        return page[index % this.PAGE_SIZE];
      } else if (page !== null) {
        if (!lazy) {
          this.fetchPage_(pageNumber);
        }
      }
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return this.numItems;
    }
  }, {
    key: "setItemAtIndex",
    value: function setItemAtIndex(index, item) {
      var pageNumber = Math.floor(index / this.PAGE_SIZE);
      var page = this.loadedPages[pageNumber]; // Only update the screen if the destination is currently loaded

      if (page) {
        page[index % this.PAGE_SIZE] = item;
      }
    }
  }, {
    key: "fetchPage_",
    value: function fetchPage_(pageNumber) {
      var _this = this;

      var self = this;
      self.searching = true; // Set the page to null so we know it is already being fetched.

      self.loadedPages[pageNumber] = null;
      var pageOffset = pageNumber * self.PAGE_SIZE;
      var sortField = self.$stateParams.sortField ? self.$stateParams.sortField : 'alias';
      var sortDirection = self.$stateParams.sortDirection ? self.$stateParams.sortDirection : 'ASC';
      var sortType = 'destination';
      this.$timeout(function () {
        // Filter out blank values, since we don't want to search by those
        for (var prop in _this.SearchParams) {
          if (_this.SearchParams.hasOwnProperty(prop)) {
            _this.SearchParams[prop] = _this.SearchParams[prop] === '' || _this.SearchParams[prop] === null ? undefined : _this.SearchParams[prop];
          }
        }

        _this.SearchParams.offset = pageOffset;
        _this.SearchParams.limit = self.PAGE_SIZE;
        _this.SearchParams.sortField = sortField;
        _this.SearchParams.sortDirection = sortDirection;
        _this.SearchParams.sortType = sortType;
        var sendParams = angular.copy(_this.SearchParams);

        if (sendParams.callLetter !== undefined) {
          // if they only entered one, then do a "LIKE" search via the alias param.  If multiple, then format it correctly and send via multiCallLetter param.
          var parsedInput = sendParams.callLetter.trim().split(/\n+|,+|;+/);

          if (parsedInput instanceof Array && parsedInput.length > 1) {
            var validArray = []; //remove any that ended up empty due to extra characters, and trim

            for (var i = 0; i < parsedInput.length; i++) {
              if (parsedInput[i].trim().length > 0) {
                validArray.push(parsedInput[i].trim());
              }
            }

            sendParams.multiCallLetter = validArray.join();
          } else {
            sendParams.alias = sendParams.callLetter;
          }
        }

        sendParams.ripleyView = true; // TODO: Append all of these values to the params object from $stateParams so we can send one big object

        _this.DestinationResourceFactory.getAll(sendParams, {}, function success(destinations) {
          self.loadedPages[pageNumber] = destinations.data.rows;
          self.numItems = destinations.data.count;
          self.searching = false;
          self.exportUrl = destinations.data.exportUrl;
        }, function failure(err) {
          console.log(err);
          self.loadedPages[pageNumber] = [];
        });
      });
    }
  }, {
    key: "reloadPages_",
    value: function reloadPages_() {
      /**
       * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
       */
      this.loadedPages = {};
      /** @type {number} Total number of items. */

      this.numItems = 0;
      /** @const {number} Number of items to fetch per request. */

      this.PAGE_SIZE = 50;
      this.getItemAtIndex(0);
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /* INITIALIZATION */

  }, {
    key: "$onInit",
    value: function $onInit() {}
  }]);

  return DynamicDestinations;
}();